<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        width: '100%',
        minHeight: '40%',
        borderTopLeftRadius: '30px',
        borderTopRightRadius: '30px',
        background: '#3D2E22',
        boxShadow: 'inset 0px 2px 0px 0px rgba(221, 122, 51, 1)',
        zIndex: '10001'
    }">
        <div class="content">
            <div class="middle_title">{{ $t('profile.logoutCurrAcc') }}</div>
            <div class="tip">
                {{ $t('profile.rememberPassword') }}
            </div>
            <div class="loagout_btn" @click="logOut">{{ $t('profile.toLogout') }}</div>
            <div class="cancel_btn" @click="close">{{ $t('profile.cancel') }}</div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { ref, defineExpose } from 'vue'
const show = ref(false)
const userStore = useUserStore()
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}
const logOut = () => {
    userStore.signOut()
    sessionStorage.setItem('openPromotionPopup', '');
}
defineExpose({
    open,
})

</script>
<style scoped>
.title {
    padding: 10px 25px;
    font-size: 14px;
    background-color: #ffffff0a;
    color: #ffffffa6;
    font-size: 20px;
    display: flex;
    justify-content: center;
    height: 45px;
}


.van-overlay {
    background-color: #00000047;
    backdrop-filter: blur(20px) !important;
    z-index: 3000 !important;
}


.content {
    padding: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 10001;
}

.content img {
    width: 100px;
}

.middle_title {
    color: #fff;
    font-size: 15px;
    padding: 15px;
}

.tip {
    color: #ffffffa6;
    font-size: 13px;
    padding: 15px 5px;
    text-align: center;
}

.cancel_btn {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    padding: 12px;
    width: 250px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    margin: 5px 0;
}

.loagout_btn {
    color: #EB5757;
    font-size: 15px;
    padding: 12px;
    width: 250px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    margin: 5px 0;
}
</style>